import { Accordion, Button, Form, InputGroup, Modal, Table } from "react-bootstrap";
import SimpleBar from "simplebar-react";
import arrayUtilities from "../../../utilities/arrayUtilities";
import FilterBar from "../../common/filterBar";
import DatePicker from 'react-datepicker';
import { useEffect, useState } from "react";
import stringUtilities from "../../../utilities/stringUtilities";
var hash = require('object-hash');

export default function FiltersToolbox(props) {

    const [workflowsModalIsVisible, setWorkflowsModalIsVisible] = useState(false);
    
    const [jobsFilter, setJobsFilter] = useState("");
    const [filteredJobs, setFilteredJobs] = useState([]);

    const onJobsSelected = function (e) {
        if (props.onJobsSelected) {
            props.onJobsSelected(arrayUtilities.toggle(e.target.value, props.selectedJobs, e.target.checked))
        }
    }

    const onUsersSelected = function (e) {
        if (props.onUsersSelected) {
            props.onUsersSelected(arrayUtilities.toggle(e.target.value, props.selectedUsers, e.target.checked));
        }
    }

    const onDateFromSelected = function (date) {
        if (props.onDateFromSelected) {
            props.onDateFromSelected(date);
        }
    }

    const onDateToSelected = function (date) {
        if (props.onDateToSelected) {
            props.onDateToSelected(date);
        }
    }

    const clearDates = function () {
        onDateFromSelected(null);
        onDateToSelected(null);
    }

    const toggleWorkflow = function (index) {
        let checkbox = document.getElementById(`workflow-all-${index}`);
        if (checkbox) {
            checkbox.click();
        }
    }

    const toggleAllWorkflow = function (e) {
        toggleWorkflowPoints(e);
        toggleWorkflowLines(e);
        toggleWorkflowPointsLines(e);
    }

    const toggleWorkflowPoints = (e) => toggleWorkflowItem(e, props.workflowPoints, props.onWorkflowPointsSelected);
    const toggleWorkflowLines = (e) => toggleWorkflowItem(e, props.workflowLines, props.onWorkflowLinesSelected)
    const toggleWorkflowPointsLines = (e) => toggleWorkflowItem(e, props.workflowPointsLines, props.onWorkflowPointsLinesSelected);

    const toggleWorkflowItem = function (e, array, callback) {
        let selectedWorkflows = arrayUtilities.toggle(e.target.value, array, e.target.checked);

        if (callback) {
            callback(selectedWorkflows);
        }
    }

    const toggleAllWorkflows = function (e) {
        toggleAllPoints(e);
        toggleAllLines(e);
        toggleAllPointsLines(e);
    }

    const toggleAllPoints = (e) => { toggleWorkflows(e, props.onWorkflowPointsSelected) }
    const toggleAllLines = (e) => { toggleWorkflows(e, props.onWorkflowLinesSelected) }
    const toggleAllPointsLines = (e) => { toggleWorkflows(e, props.onWorkflowPointsLinesSelected) }

    const toggleWorkflows = function (e, callback) {
        let selectedWorkflows = e.target.checked ? props.workflows?.map((x) => x.id) : [];

        if (callback) {
            callback(selectedWorkflows);
        }
    }

    useEffect(() => {
        setFilteredJobs(arrayUtilities.isNullOrEmpty(props.jobs) ? [] : props.jobs.filter((job) => {
            return stringUtilities.isNullOrEmpty(jobsFilter) || job.name.toLowerCase().indexOf(jobsFilter.toLowerCase()) > -1;
        }));
    }, [jobsFilter, props.jobs]);

    return <>
        <Accordion.Item eventKey='1'>
            <Accordion.Header><i className="fi-filter me-2" /> Filters</Accordion.Header>
            <Accordion.Body>
                <div className='border-bottom pb-3 mb-2'>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <p className="text-body fs-sm me-0 pe-1 text-nowrap mb-0">Jobs</p>
                        <FilterBar value={jobsFilter} onChange={setJobsFilter} />
                    </div>
                    <SimpleBar autoHide={false} className='simplebar-no-autohide' style={{ maxHeight: '11rem' }}>
                        {!arrayUtilities.isNullOrEmpty(filteredJobs) && <>
                            {filteredJobs.map((job, index) => (
                                <Form.Check key={index} id={`job-${index}`} value={job.id} defaultChecked={props.selectedJobs?.includes(job.id)} onChange={onJobsSelected} label={<><span className='fs-sm'>{job.name}</span></>} />
                            ))}
                        </>
                        }
                    </SimpleBar>
                </div>

                <div className='border-bottom pb-2'>
                    <div className="row d-flex align-items-center">
                        <p className="col-6 mt-3 text-body fs-sm text-nowrap">Workflows</p>
                        <div className="col-6 d-flex justify-content-end">
                            <Button size="sm" variant='secondary' onClick={() => setWorkflowsModalIsVisible(true)}>
                                <i className='fi-layers me-2'></i> Select workflow layers
                            </Button>
                        </div>
                    </div>
                </div>

                {!arrayUtilities.isNullOrEmpty(props.users) &&
                    <div className='border-bottom pt-3 pb-3 mb-2'>
                        <p className="text-body fs-sm me-0 pe-1 text-nowrap">Users</p>
                        <SimpleBar autoHide={false} className='simplebar-no-autohide' style={{ maxHeight: '11rem' }}>
                            {props.users.map((user, index) => (
                                <Form.Check key={index} id={`user-${index}`} value={user.id} defaultChecked={props.selectedUsers.includes(user.id)} onChange={onUsersSelected} label={<><span className='fs-sm'>{user.name}</span></>} />
                            ))}

                        </SimpleBar>

                    </div>
                }

                <div className='border-bottom pt-2 pb-4 mb-2'>
                    <p className="text-body fs-sm me-0 pe-1 text-nowrap">Dates</p>
                    <InputGroup className='flex-nowrap' size='sm'>
                        <InputGroup.Text>
                            <i className='fi-calendar'></i>
                        </InputGroup.Text>
                        <Form.Control as={DatePicker} size='sm' selected={props.dateFrom ? new Date(props.dateFrom) : null} onChange={(date) => onDateFromSelected(date)} dateFormat="dd/MM/yyyy" selectsStart startDate={props.dateFrom ? new Date(props.dateFrom) : null} endDate={props.dateTo ? new Date(props.dateTo) : null} maxDate={props.dateTo ? new Date(props.dateTo) : null} placeholderText='From' className='rounded-0' />
                        <Form.Control as={DatePicker} size='sm' selected={props.dateTo ? new Date(props.dateTo) : null} onChange={(date) => onDateToSelected(date)} dateFormat="dd/MM/yyyy" selectsEnd startDate={props.dateFrom ? new Date(props.dateFrom) : null} endDate={props.dateTo ? new Date(props.dateTo) : null} minDate={props.dateFrom ? new Date(props.dateFrom) : null} placeholderText='To' className='rounded-start-0' />
                        <Button variant="outline-secondary" onClick={clearDates}>
                            <i className='fi-x'></i>
                        </Button>
                    </InputGroup>
                </div>
                <div className="border-bottom pt-2 mt-2 pb-2">
                    <div className="row d-flex align-items-center">
                        <p className="m-0 col-6 text-body fs-sm me-0 pe-1 text-nowrap">Move data</p>
                        <div className="col-6 d-flex justify-content-end">
                            <Button size="sm" variant='secondary' onClick={() => props.onMoveDataClick()} disabled={!props.isMultiTransferEnabled}>
                                <i className='fi-external-link me-2'></i> Move all visible data
                            </Button>
                        </div>
                    </div>
                    <div className="row d-flex align-items-center pt-2 mt-1">
                        <p onClick={() => props.setIncludeDeleted(prevState => !prevState)} className="col-6 mt-3 text-body fs-sm me-0 pe-1 text-nowrap cursor-pointer">Include deleted data</p>
                        <div className="col-6 d-flex justify-content-end pr-0">
                            <div>
                                <InputGroup size="sm">
                                    <Form.Check type='switch' id="include-deleted-data" className="pt-1" checked={props.includeDeleted} onChange={(e) => props.setIncludeDeleted(e.target.checked)} />
                                </InputGroup>
                            </div>
                        </div>
                    </div>
                </div>
            </Accordion.Body>
        </Accordion.Item>

        <Modal show={workflowsModalIsVisible} onHide={() => setWorkflowsModalIsVisible(false)} centered size="lg">
            <Modal.Header>
                <Modal.Title>Workflow Layers</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Table responsive>
                    <thead>
                        <tr>
                            <th>Workflow</th>
                            <th><Form.Check id={`workflow-all`} checked={props.workflowPoints?.length === props.workflows?.length && props.workflowLines?.length === props.workflows?.length && props.workflowPointsLines?.length === props.workflows?.length} onChange={toggleAllWorkflows} className="py-0 m-0" label={<><span>All</span></>} /></th>
                            <th><Form.Check id={`workflow-points-all`} checked={props.workflowPoints?.length === props.workflows?.length} onChange={toggleAllPoints} className="py-0 m-0" label={<><span>Points</span></>} /></th>
                            <th><Form.Check id={`workflow-lines-all`} checked={props.workflowLines?.length === props.workflows?.length} onChange={toggleAllLines} className="py-0 m-0" label={<><span>Lines</span></>} /></th>
                            <th><Form.Check id={`workflow-points-lines-all`} checked={props.workflowPointsLines?.length === props.workflows?.length} onChange={toggleAllPointsLines} className="py-0 m-0" label={<><span>Points on lines</span></>} /></th>
                        </tr>
                    </thead>
                    <tbody>
                        {!arrayUtilities.isNullOrEmpty(props.workflows) && <>
                            {props.workflows.map((workflow, index) => <tr index={index} key={`workflow-layer-${workflow.id}`}>
                                <td>
                                    <Button variant="link" className="p-0" size="sm" onClick={() => toggleWorkflow(index)}>{workflow.name}</Button>
                                </td>
                                <td><Form.Check key={hash({ id: workflow.id, workflowPoints: props.workflowPoints, workflowLines: props.workflowLines, workflowPointsLines: props.workflowPointsLines })} id={`workflow-all-${index}`} value={workflow.id} checked={props.workflowPoints?.includes(workflow.id) && props.workflowLines?.includes(workflow.id) && props.workflowPointsLines?.includes(workflow.id)} onChange={toggleAllWorkflow} /></td>
                                <td><Form.Check key={hash({ id: workflow.id, workflowPoints: props.workflowPoints })} id={`workflow-points-${index}`} value={workflow.id} checked={props.workflowPoints?.includes(workflow.id)} onChange={toggleWorkflowPoints} /></td>
                                <td><Form.Check key={hash({ id: workflow.id, workflowLine: props.workflowLines })} id={`workflow-lines-${index}`} value={workflow.id} checked={props.workflowLines?.includes(workflow.id)} onChange={toggleWorkflowLines} /></td>
                                <td><Form.Check key={hash({ id: workflow.id, workflowPointsLines: props.workflowPointsLines })} id={`workflow-points-lines-${index}`} value={workflow.id} checked={props.workflowPointsLines?.includes(workflow.id)} onChange={toggleWorkflowPointsLines} /></td>
                            </tr>)}
                        </>}
                    </tbody>
                </Table>
            </Modal.Body>
            <Modal.Footer>
                <Button size="sm" variant="primary" onClick={() => setWorkflowsModalIsVisible(false)}>Finish</Button>
            </Modal.Footer>
        </Modal>
    </>
}